export default __webpack_public_path__ + "static/media/lifesatisfaction3Img6.ff9b3bbd.png";